var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeatherArrowRightIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2521 8.10604C15.2521 9.48492 14.8432 10.8328 14.0772 11.9793C13.3111 13.1258 12.2223 14.0194 10.9483 14.5471C9.67441 15.0748 8.27263 15.2128 6.92024 14.9438C5.56785 14.6748 4.3256 14.0108 3.35058 13.0358C2.37556 12.0608 1.71156 10.8186 1.44256 9.46616C1.17355 8.11377 1.31161 6.71198 1.83929 5.43806C2.36697 4.16414 3.26056 3.0753 4.40706 2.30923C5.55356 1.54316 6.90147 1.13428 8.28036 1.13428C9.1959 1.13428 10.1025 1.31461 10.9483 1.66497C11.7942 2.01533 12.5628 2.52887 13.2101 3.17626C13.8575 3.82365 14.3711 4.59221 14.7214 5.43806C15.0718 6.28391 15.2521 7.19049 15.2521 8.10604V8.10604Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.2793 10.8948L11.068 8.10609L8.2793 5.31738",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.49023 8.10596H11.0676",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatherArrowRightIcon);
export default __webpack_public_path__ + "static/media/feather-arrow-right-icon.429448332344780ffbb1fe121a51347d.svg";
export { ForwardRef as ReactComponent };